export const CademyTerms = () => {
    return (
        <>
            <h2>Cademy&apos;s Terms of Service</h2>
            <p>
                Please note that when these terms mention &quot;Cademy&quot;, &quot;we&quot;,
                &quot;us&quot; or &quot;our&quot;, it refers to &quot;Cademy Group Limited&quot;,
                incorporated at: Floor 1, 27 Queen Charlotte Street, Edinburgh, EH6 6AX , UK.
            </p>
            <h3>Our services</h3>
            <p>
                <a href={process.env.NEXT_PUBLIC_MARKETPLACE_URL}>Cademy</a> offers course discovery
                and booking services. We make it easier for learners to access local courses and for
                educators of all sizes to reach new customers.
            </p>
            <h3>Our commitments</h3>
            <p>
                We commit to using all reasonable efforts to ensure that all user data is processed
                securely and privately in line with our{' '}
                <a href={`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/privacy`}>Privacy Policy</a>.
                We are committed to offering live support to all users of the platform and respond
                to all enquiries within 24 hours. We will use all reasonable efforts to ensure
                99.99% service uptime. We commit to never misuse data we process and we commit to
                never share user data with unauthorised third parties.
            </p>
            <h3>Our requirements</h3>
            <p>
                We require all users in control of data to be 18 years or older. All content
                published on our platform must either be owned by the user or under a creative
                commons license. We will not tolerate abusive, harmful, disruptive or hateful
                behaviour from users of our platform.
            </p>
            <h3>Fees and payments</h3>
            <p>
                We charge transaction fees on paid orders delivered through our platform. Our fees
                will be detailed in the{' '}
                <a href={`${process.env.NEXT_PUBLIC_MARKETPLACE_URL}/pricing`}>Pricing</a> section
                of our website. In cases of cancellations and refunds, we shall refund our
                transaction charges to the customer.
            </p>
            <h3>Liability</h3>
            <p>
                Cademy will be liable for any negligent breaches of essential contractual
                obligations by us, or our legal agents. Our liability shall be limited to the
                typically occurring foreseeable damages caused by our negligence or terms breach.
                Cademy shall not be held liable for the quality, delivery or negligence of our
                educators, partners or users.
            </p>
            <h3>Breach of terms</h3>
            <p>
                We reserve the right to un-publish all content and block any user accounts that
                breach our terms of services. In case of a breach on our part, we shall offer users
                the ability to export all content and data from our platform at no cost.
            </p>
            <h3>Modification of terms</h3>
            <p>
                We reserve the right to modify these terms at any time. We commit to notifying all
                users of any changes in our terms at least 30 days prior to the changes taking
                action.
            </p>

            <p>
                <strong>Questions?</strong>
            </p>
            <p>
                If you have questions or feedback, please email{' '}
                <a href={`mailto:${process.env.NEXT_PUBLIC_CADEMY_SUPPORT_EMAIL_ADDRESS}`}>
                    {process.env.NEXT_PUBLIC_CADEMY_SUPPORT_EMAIL_ADDRESS}
                </a>
                . We are always happy to hear from you.
            </p>
        </>
    );
};
